import {game_5008} from "../slots/game_5008";
import {game_5009} from "../slots/game_5009";
import {game_5010} from "../slots/game_5010";
import {game_305} from "../slots/game_305";
import {game_5012} from "../slots/game_5012";
import {game_5015} from "../slots/game_5015";
import {Game_5016} from "../slots/game_5016";
import {game_5007_5013} from "../slots/game_5007_5013";
import {game_5006} from "../slots/game_5006";
import {game_5005} from "../slots/game_5005";
import {game_5004} from "../slots/game_5004";
import {game_5011} from "../slots/game_5011";
import {game_5014} from "../slots/game_5014";
import {game_5000_to_5003} from "../slots/game_5000_to_5003";
import {slots_utils} from "../../../untils/slots_utils";
import {common_utils} from "../common/common_utils";
import {slots_tool} from "../slots/slots_tool";
import {game_100} from "../slots/game_100";
import {game_101} from "../slots/game_101";
import {game_102} from "../slots/game_102";
import {game_103} from "../slots/game_103";
import {game_104} from "../slots/game_104";
import {game_300} from "../slots/game_300";
import {game_301} from "../slots/game_301";
import {game_302} from "../slots/game_302";
import {game_303} from "../slots/game_303";
import {game_304} from "../slots/game_304";

function detail_by_token()
{

}

detail_by_token.readDataValue = function(this1, data)
{
  this1.winValueTotal = null;
  this1.esports = true
  let winValueList = [];
  let odd_map = null;
  common_utils.readDataValue(this1,data);
  if(data.gameId === 100)
  {
    odd_map = game_100.odd_map;
  }
  else if(data.gameId === 101)
  {
    odd_map = game_101.odd_map;
  }
  else if(data.gameId === 102)
  {
    odd_map = game_102.odd_map;
  }
  else if(data.gameId === 103)
  {
    odd_map = game_103.odd_map;
  }
  else if(data.gameId === 104)
  {
    odd_map = game_104.odd_map;
  }
  else if (data.gameId === 300)
  {
    odd_map = game_300.odd_map;
  }
  else if(data.gameId === 301)
  {
    odd_map = game_301.odd_map;
  }
  else if(data.gameId === 302)
  {
    odd_map = game_302.odd_map;
  }
  else if(data.gameId === 303)
  {
    odd_map = game_303.odd_map;
  }
  else if(data.gameId === 304)
  {
    odd_map = game_304.odd_map;
  }

  if (data.detail && data.detail.spinResults)
  {
    this1.result = data.detail.spinResults
    this1.mapList = this1.result[0].map
    this1.bonuswin = (this1.result[0].bonusWinValue / 100).toFixed(2)
    let bonusWinValue = this1.result[0].bonusWinValue / 100;
    if (this1.result.length >= 2)
    {
        this1.isHasTwo = true
        this1.mapListTwo = this1.result[1].map
    }
    // 匹配下标
    let s = new slots_utils();
    this1.geValue = s.showSlotsWinLine(data.gameId, this1.mapList).m_dict
    this1.winlines = [];
    this1.winlines.push(s.showSlotsWinLineInfo(data.gameId, this1.mapList))

    if (Object.keys(this1.geValue).length !== 0)
    {
      for (var i = 0; i < Object.keys(this1.geValue).length; i++)
      {
          var mapIndexTmp = Object.values(this1.geValue)[i].flat(Infinity)
          for (var j = 0; j < mapIndexTmp.length; j++)
          {
              this1.mapIndex.push(mapIndexTmp[j])
          }
          var detail = {}
          var lines = 1;
          var mapIndexFullTmp = Object.values(this1.geValue)[i]
          for (var j = 0; j < mapIndexFullTmp.length; j++) {
            lines = lines * mapIndexFullTmp[j].length
          }

          detail.key = Object.keys(this1.geValue)[i]
          detail.lines = lines
          detail.length = Object.values(this1.geValue)[i].length
          if (odd_map !=null)
          {
            detail = slots_tool.winInfo(odd_map,detail,0);
          }
          winValueList.push(detail.winValue);
          this1.mapListDetail.push(detail)
      }

    }
    if (this1.isHasTwo)
    {
        this1.mapIndexTwo = []
        this1.mapListDetailTwo = []
        var geValueTmp = s.showSlotsWinLine(data.gameId, this1.mapListTwo).m_dict
        this1.winlines.push(s.showSlotsWinLineInfo(data.gameId, this1.mapListTwo))

        if (Object.keys(geValueTmp).length != 0)
        {
            for (var i = 0; i < Object.keys(geValueTmp).length; i++)
            {
                var mapIndexTmp = Object.values(geValueTmp)[i].flat(Infinity)
                for (var j = 0; j < mapIndexTmp.length; j++)
                {
                  this1.mapIndexTwo.push(mapIndexTmp[j])
                }
                var detail = {}
                var lines = 1;
                var mapIndexFullTmp = Object.values(geValueTmp)[i]
                for (var j = 0; j < mapIndexFullTmp.length; j++)
                {
                    lines = lines * mapIndexFullTmp[j].length
                }
                detail.key = Object.keys(geValueTmp)[i]
                detail.lines = lines
                detail.length = Object.values(geValueTmp)[i].length
                if (odd_map !=null)
                {
                   detail = slots_tool.winInfo(odd_map,detail,0);
                }
                winValueList.push(detail.winValue);
                this1.mapListDetailTwo.push(detail)
          }
        }
    }
    this1.bonus_id = this1.result[0].bonusId
    var isFree = 0;
    if (data.gameId == 100)
    {
      let detailBet = slots_tool.detailBet(data);
      if(data.detail.spinType == 0)
      {
        this1.isfree = '普通'
      }
      else if(data.detail.spinType == 1)
      {
        this1.isfree = '免费游戏'
        isFree = 1;
      }
      else if((data.detail.spinType == 4) || (data.detail.spinType == 5))
      {
        this1.isfree = '购买免费游戏'
        detailBet = data.detail.realBet;
        isFree = 0;
      }
      else if(data.detail.spinType == 8) {
        this1.isfree = '购买彩金游戏'
        detailBet = data.detail.realBet;
        isFree = 0;
      }
      this1.winValueTotal = slots_tool.TotalValue(winValueList,detailBet,50,isFree,false,0,bonusWinValue);
    }
    else
    {
        this1.isfree = common_utils.isFreeTip(data)
        if (data.gameId == 101)
        {
          this1.winValueTotal = slots_tool.TotalValue(winValueList,slots_tool.detailBet(data),50,slots_tool.isFree(data),false,0,bonusWinValue,0,true);
        }
        else
        {
          this1.winValueTotal = slots_tool.TotalValue(winValueList,slots_tool.detailBet(data),50,data.isFree,false,0,bonusWinValue);
        }
    }
    slots_tool.drawSlotLines(this1,this1.winlines)
  }
  else if(data.gameId == 305)
  {
    game_305.readDataValue(this1,data)
  }
  else if (data.gameId == 5010)
  {
    game_5010.readDataValue(this1,data)
  }
  else if (data.gameId == 5009)
  {
    game_5009.readDataValue(this1,data)
  }
  else if (data.gameId === 5008) {
    game_5008.readDataValue(this1,data);
  }
  else if (data.gameId == 5012)
  {
    game_5012.readDataValue(this1,data);
  }
  else if (data.gameId == 5015)
  {
    game_5015.parseResult(this1,data);
  }
  else if (data.gameId == 5016)
  {
    Game_5016.parseResult(this1,data);
  }

  else if (data.gameId == 5007 || data.gameId == 5013) {

    game_5007_5013.readDataValue(this1,data)
  }
  else if (data.gameId == 5006)
  {
    game_5006.readDataValue(this1,data)
  }
  else if (data.gameId == 5005) {
    game_5005.readDataValue(this1,data)

  }
  else if (data.gameId == 5004)
  {
    game_5004.readDataValue(this1,data);
  }
  else if (data.gameId == 5011)
  {
    game_5011.readDataValue(this1,data);
  }
  else if (data.gameId == 5014)
  {
    game_5014.readDataValue(this1,data)
  }
  else if (data.gameId == 5000 || data.gameId == 5001 || data.gameId == 5002 || data.gameId == 5003)
  {
    game_5000_to_5003.readDataValue(this1,data)
  }
}


export {
  detail_by_token
};



// WEBPACK FOOTER //
// ./src/components/data/detail_by_token.js